import { render } from "./Index.vue?vue&type=template&id=2a4e428a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=2a4e428a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Customers/Teams/Edit/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a4e428a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a4e428a', __exports__)) {
    api.reload('2a4e428a', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=2a4e428a", () => {
    api.rerender('2a4e428a', render)
  })

}


export default __exports__